import { jsx as _jsx } from "react/jsx-runtime";
import { useUIStore } from '../store/ui-store';
import { SUPPORTED_LOCALES } from '../utils/locale';
const localeLabels = {
    en: 'EN',
    fa: 'FA',
    ar: 'AR',
    ru: 'RU',
    tr: 'TR',
    fr: 'FR',
    it: 'IT',
    de: 'DE',
    es: 'ES',
};
export function LocaleSwitcher() {
    const locale = useUIStore((state) => state.locale);
    const setLocale = useUIStore((state) => state.setLocale);
    return (_jsx("select", { value: locale, onChange: (e) => setLocale(e.target.value), className: "input text-sm min-w-20", "aria-label": "Language", children: SUPPORTED_LOCALES.map((code) => (_jsx("option", { value: code, children: localeLabels[code] }, code))) }));
}
//# sourceMappingURL=LocaleSwitcher.js.map